import { Component } from '@angular/core';

@Component({
  selector: 'app-hire-better-section',
  templateUrl: './hire-better-section.component.html',
  styleUrls: ['./hire-better-section.component.css']
})
export class HireBetterSectionComponent {

}
